import React from "react";
import { AERole } from "../../../../../../_emywork/components/AERole";
import FilterWrapper from "../../../../../../_metronic/layout/components/filters/FilterWrapper";
import GenericFilter from "../../../../../../_metronic/layout/components/filters/GenericFilter";
import HeartFilter from "../../../../../../_metronic/layout/components/filters/HeartFilter";
import SearchFilter from "../../../../../../_metronic/layout/components/filters/SearchFilter";
import UsersFilter from "../../../../../../_metronic/layout/components/filters/UsersFilter";
import { getFilterProps } from "../../../../../../_metronic/_helpers/forms";

import { roles } from "../../../../../App";
import { useFilterFormik } from "../../../../common/hooks";
import { walletsInitialFilter, walletsSorts } from "./filterHelpers";

const TransactionsFilter = ({
  setFilters,
  filters,
  setSort,
  sort,
  setSortAsc,
}) => {
  const { formik, advancedFilter, setAdvancedFilter } = useFilterFormik(
    (values) => {
      const { holder_id, search } = values;
      filters = { search, holder_id: holder_id.id || "" };
      setFilters(filters);
    },
    walletsInitialFilter
  );

  const {
    handleSubmit,
    resetForm,
    getFieldProps,
    values,
    setFieldValue,
  } = formik;
  const mapPropsToFormik = getFilterProps({ formik, getFieldProps });
  return (
    <>
      <FilterWrapper
        message={{ id: "WALLETS" }}
        FilterForm={TransactionsFilterForm}
        filterFormProps={{ mapPropsToFormik, values, setFieldValue }}
      >
        <HeartFilter />
        <GenericFilter
          setSort={setSort}
          setSortAsc={setSortAsc}
          sorts={walletsSorts}
          sort={sort}
          handlesubmit={handleSubmit}
          resetForm={resetForm}
          advancedFilter={advancedFilter}
          setAdvancedFilter={setAdvancedFilter}
        />
      </FilterWrapper>
    </>
  );
};

export default TransactionsFilter;

export const TransactionsFilterForm = ({
  mapPropsToFormik,
  values,
  setFieldValue,
}) => {
  return (
    <form className="bg-white rounded pt-0 pb-4 px-2 row">
      <SearchFilter mapPropsToFormik={mapPropsToFormik} />
      <div className={`col-lg-3`}>
        <AERole accept={[roles.super_admin]}>
          <UsersFilter value={values.holder_id} setFieldValue={setFieldValue} />
        </AERole>
      </div>
    </form>
  );
};
